import React, { useState } from 'react';
import StoreList from '../components/Store/StoreList';
import StoreMap from '../components/Store/StoreMap';
import StoreDetail from '../components/Store/StoreDetail';
import monserratImg from '../imagenes/detalle-caballito.jpg';
import caballitoImg from '../imagenes/detalle-monserrat.jpg';
import villaImg from '../imagenes/detalle-villa-crespo.jpg';
import palermoImg from '../imagenes/detalle-palermo.jpg'

import './StorePage.css';

const StorePage = () => {
  const [view, setView] = useState('list');
  const [selectedStore, setSelectedStore] = useState(null);

  const stores = [
    {
      id: 1,
      name: 'Monserrat',
      address: 'Av Boedo 1356 (Boedo, CABA)',
      hours: 'lunes a viernes 8 am - 22 PM',
      image: monserratImg,
      coordinates: { lat: -34.625, lng: -58.416 },
      description: 'Esta tienda esta ubicada en el corazón del barrio de Monserrat',
      features: ['Asientos al aire libre', 'WiFi', 'Takeaway']
    },
    {
      id: 2,
      name: 'Caballito',
      address: 'Av Rivadavia 2381 (Caballito, CABA)',
      hours: 'lunes a viernes 8 am - 22 PM\nsabado 9 AM - 21 PM',
      image: caballitoImg,
      coordinates: { lat: -34.618, lng: -58.441 },
      description: 'Esta sucursal ubicada en el corazón del barrio de Caballito es una de las más pintorescas, y cuenta con mesas al aire libre para disfrutar de un buen café en contacto con el aire libre.',
      features: ['Asientos al aire libre', 'Instagrammable', 'Familiar' , 'pet friendly']
    },
    {
      id: 3,
      name: 'Villa Crespo',
      address: 'Habana 954 (Crespo, CABA)',
      hours: 'lunes a viernes 7 AM - 23 PM\nsabado 8 AM - 1 AM\ndomingo 8 AM - 22 PM',
      image: villaImg,
      coordinates: { lat: -34.599, lng: -58.445 },
      description: 'Ubicado en el centro neurálgico de Villa Crespo, es una excelente opción para degustar un café de calidad.',
      features: ['Habierto hasta tarde', 'Café de calidad', 'Ubicación central']
    },
        {
      id: 4,
      name: 'Palermo',
      address: 'Serrano 1382 (Palermo, CABA)',
      hours: 'lunes a viernes 9 AM - 00 AM\nsabado 8 AM - 1 AM\ndomingo 8 AM - 22 PM',
      image: palermoImg,
      coordinates: { lat: -34.599, lng: -58.445 },
      description: 'Ubicado en el centro de Palermo SOHO, es una excelente opción para degustar un café de calidad.',
      features: ['Atencion dedicada', 'Café de calidad', 'Ubicación central']
    }
  ];

  const handleStoreSelect = (store) => {
    setSelectedStore(store);
    setView('detail');
  };

  const handleBackToList = () => {
    setView('list');
    setSelectedStore(null);
  };

  const handleBackToMap = () => {
    setView('map');
    setSelectedStore(null);
  };

  return (
    <div className="store-page">
      {view !== 'detail' && (
        <div className="store-header">
          <h1>Encuentra tu tienda favorita más cercana</h1>
          <div className="view-toggle">
            <button 
              className={`toggle-btn ${view === 'list' ? 'active' : ''}`}
              onClick={() => setView('list')}
            >
              LISTA
            </button>
            <button 
              className={`toggle-btn ${view === 'map' ? 'active' : ''}`}
              onClick={() => setView('map')}
            >
              MAPA
            </button>
          </div>
        </div>
      )}

      {view === 'list' && (
        <StoreList 
          stores={stores} 
          onStoreSelect={handleStoreSelect}
        />
      )}

      {view === 'map' && (
        <StoreMap 
          stores={stores}
          onStoreSelect={handleStoreSelect}
          onBackToList={handleBackToList}
        />
      )}

      {view === 'detail' && selectedStore && (
        <StoreDetail 
          store={selectedStore}
          onBack={view === 'list' ? handleBackToList : handleBackToMap}
        />
      )}
    </div>
  );
};

export default StorePage;